
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Route } from 'vue-router';
import DateRange from '@/components/DateRange.vue';
import api from '@/api';
import Util from '@/utils/util';

const { pointVoucher, swapInPoint } = api;

interface swapInItemModel {
  itemId: number;
  itemName: string;
}

@Component({
  components: { DateRange },
})
export default class SwapInPointVoucherList extends Vue {
  private data = { data: [], totalCount: 0, pageSize: 20, pageNo: 0 };

  private statusSelect: Array<{ text: string; value: number }> = [
    { text: '未啟用', value: 0 },
    { text: '啟用', value: 1 },
    { text: '已兌換', value: 2 },
    { text: '已作廢', value: 3 },
    { text: '已過期', value: 4 },
    { text: '已鎖定', value: 5 },
  ];

  private swapInItems: Array<swapInItemModel> = [];

  private loading = false;

  private panel = 0;

  private headers = [
    { text: '序號', value: 'voucherNo' },
    { text: '兌換來源', value: 'itemName' },
    { text: '點數', value: 'pointValue' },
    { text: '狀態', value: 'status' },
    { text: '兌換會員ID', value: 'publicUserId' },
    { text: '到期日', value: 'expiryDate' },
    { text: '建立日期', value: 'createdOn' },
    { text: '異動日期', value: 'modifiedOn' },
  ];

  private get totalCount() {
    return this.data.totalCount;
  }

  private get pageCount() {
    return Math.ceil((this.data.totalCount || 0) / (this.data.pageSize || 20));
  }

  private get collection() {
    return [...(this.data.data || [])];
  }

  private filter = {
    voucherNo: this.$route.query.voucherNo
      ? this.$route.query.voucherNo
      : undefined,
    itemId: this.$route.query.itemId ? this.$route.query.itemId : undefined,
    voucherStatus: this.$route.query.voucherStatus
      ? this.$route.query.voucherStatus
      : undefined,
    startDate: this.$route.query.startDate
      ? this.$route.query.startDate
      : undefined,
    endDate: this.$route.query.endDate ? this.$route.query.endDate : undefined,
    pageSize: Util.isNullOrUndefined(this.$route.query.pageSize)
      ? 20
      : +this.$route.query.pageSize,
    pageNo: Util.isNullOrUndefined(this.$route.query.pageNo)
      ? 1
      : +this.$route.query.pageNo,
  };

  private async setSwapInItems() {
    const {
      data: { data },
    } = await swapInPoint.itemList();
    this.swapInItems = data || [];
  }

  private async updatePage(page: number) {
    this.filter.pageNo = page;
    await this.query();
  }

  private async search() {
    this.filter.pageNo = 1;
    await this.query();
  }

  private async query() {
    const query = {
      ...this.filter,
      pageSize: `${this.filter.pageSize}`,
      pageNo: `${this.filter.pageNo}`,
    };
    if (this.isQueryChanged(query)) {
      await this.$router.replace({ query });
    }
    await this.requestData();
  }

  private async reset() {
    this.filter = {
      voucherNo: undefined,
      itemId: undefined,
      startDate: undefined,
      voucherStatus: undefined,
      endDate: undefined,
      pageSize: 20,
      pageNo: 1,
    };
    await this.query();
  }

  private isQueryChanged(query: {
    [key: string]: string | Array<string | null> | null | undefined;
  }): boolean {
    return !Object.keys(query).every(
      (key: string) => query[key]?.toString() === this.$route.query[key],
    );
  }

  private getStatusText(status: number) {
    return this.statusSelect.find((p) => p.value === status)?.text;
  }

  private async requestData() {
    this.loading = true;
    const { data } = await pointVoucher.list(this.filter);
    this.data = data;
    this.loading = false;
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: ((vm: SwapInPointVoucherList) => void) | boolean) => void,
  ) {
    await next(async (vm) => {
      await vm.requestData();
      await vm.setSwapInItems();
    });
  }
}
